<script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script>
<div style="margin-left:auto;margin-right:auto;text-align:center;">
<lottie-player
    src="assets/animated-footer.json"  background="transparent"  speed="1"  style="height: 100%;"  loop autoplay >
</lottie-player>
</div>